import { useEffect, useState } from 'react'

const useWindowHeight = (): number => {
  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    const handleResize = (): void => {
      setHeight(window.innerHeight)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return height
}

export default useWindowHeight
